import { emsClient } from '../api/clients';
import type { GeoPoint } from '../realtime';

export type AddressSearchResultItem = {
  name: string;
  label: string;
  position: GeoPoint;
  type: string;
  location: string;
};

export const MAPY_CZ_POSITION_TYPE_COORDINATE = 'coordinate';

export async function searchAddress(address: string, language: string): Promise<AddressSearchResultItem[]> {
  const { data, response } = await emsClient().POST('/portal/v1/geocoding/search', {
    body: { address, language },
  });

  if (data === undefined) {
    throw new Error(`Address search failed (HTTP ${response.status})`);
  }

  return data.map((item) => ({
    name: item.name ?? '',
    label: item.label ?? '',
    position: {
      latitude: item.position?.latitude ?? 0,
      longitude: item.position?.longitude ?? 0,
    },
    type: item.type ?? '',
    location: item.location ?? '',
  }));
}
